import StatTile from "../../common/StatTile";
import { Reveal } from "../../common/Reveal";
import { formatCount, pctDelta, UsageMetricMeta, UsageSummary } from "./usageTypes";

interface Props {
  index: number;
  label: string;
  metrics: UsageMetricMeta[];
  summary: UsageSummary;
  selectedKey: string;
  onSelect: (key: string) => void;
  hideZeros: boolean;
  /** Date tracking started, shown on counters that only begin then. */
  trackedSinceLabel: string | null;
}

export default function CategorySection({ index, label, metrics, summary, selectedKey, onSelect, hideZeros, trackedSinceLabel }: Props) {
  const visible = metrics.filter((m) => {
    const t = summary.totals[m.key];
    return !hideZeros || (t && (t.current > 0 || t.previous > 0));
  });
  if (visible.length === 0) return null;
  const sectionTotal = metrics.reduce((a, m) => a + (summary.totals[m.key]?.current || 0), 0);

  return (
    <Reveal as="section" index={index} className="space-y-2">
      <div className="flex items-baseline gap-2">
        <h3 className="m-0 text-sm font-semibold text-base-content">{label}</h3>
        <span className="text-xs text-base-content/50 tabular-nums">{formatCount(sectionTotal)}</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3">
        {visible.map((m) => {
          const t = summary.totals[m.key] || { current: 0, previous: 0, users: 0 };
          return (
            <StatTile
              key={m.key}
              label={m.label}
              value={formatCount(t.current)}
              delta={pctDelta(t.current, t.previous)}
              hint={
                t.users > 0 ? `${t.users} ${t.users === 1 ? "officer" : "officers"}` : m.trackedSince && trackedSinceLabel ? `counted since ${trackedSinceLabel}` : undefined
              }
              badge={m.trackedSince ? "new" : undefined}
              muted={t.current === 0}
              selected={selectedKey === m.key}
              onClick={() => onSelect(m.key)}
            />
          );
        })}
      </div>
    </Reveal>
  );
}
